import { render, staticRenderFns } from "./CourseSectionListFilters.vue?vue&type=template&id=64c28d54&"
import script from "./CourseSectionListFilters.vue?vue&type=script&lang=js&"
export * from "./CourseSectionListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports